'use client';

import OurTeam from './components/OurTeam';

function App() {
  return (
    <main className="py-16">
      <OurTeam />
    </main>
  );
}

export default App;
